import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';
function getColor(status) {
    switch (status) {
        case 'incomplete':
        case 'billing_hold':
        case 'canceled':
            return 'bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-900 dark:text-red-200';
        case 'hold':
            return 'bg-orange-100 text-orange-800 hover:bg-orange-100 dark:bg-orange-900 dark:text-orange-200';
        case 'ready_to_bill':
            return 'bg-blue-100 text-blue-800 hover:bg-blue-100 dark:bg-blue-900 dark:text-blue-200';
        case 'audited':
            return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100 dark:bg-yellow-900 dark:text-yellow-200';
        case 'invoiced':
            return 'bg-green-100 text-green-800 hover:bg-green-100 dark:bg-green-900 dark:text-green-200';
        default:
            return 'bg-gray-100 text-gray-800 hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-200';
    }
}
function titleCase(s) {
    return s.replace(/_/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
}
export default function BillingStatusBadge({ className = '', billingStatus, }) {
    if (!billingStatus)
        return null;
    return (React.createElement(Badge, { className: cn('self-start shrink-0 grow-0', getColor(billingStatus), className) }, titleCase(billingStatus)));
}
